import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Typography } from '@mui/material';

interface Props {
    title: string | any;
    isCritical?: boolean | any;
}

export default function RenderCriticalQuestion({ title, isCritical }: Props) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
            {isCritical && (
                <ErrorOutlineIcon
                    sx={{
                        color: 'green',
                        fontSize: '16px',
                        marginRight: '4px',
                        marginTop: '2px',
                    }}
                />
            )}
            <Typography>{title}</Typography>
        </Box>
    );
}
